"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportScheduleCreateInputSchema = exports.ReportScheduleSchema = exports.ReportScheduleRecipientSchema = exports.ReportScheduleFormatSchema = exports.ReportScheduleFrequencySchema = void 0;
const zod_1 = require("zod");
exports.ReportScheduleFrequencySchema = zod_1.z.enum(['daily', 'weekly', 'monthly']);
exports.ReportScheduleFormatSchema = zod_1.z.enum(['pdf', 'csv', 'both']);
exports.ReportScheduleRecipientSchema = zod_1.z.object({
    email: zod_1.z.string().email(),
    name: zod_1.z.string().optional(),
});
exports.ReportScheduleSchema = zod_1.z.object({
    scheduleId: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    reportType: zod_1.z.string(),
    reportParams: zod_1.z.record(zod_1.z.unknown()),
    frequency: exports.ReportScheduleFrequencySchema,
    dayOfWeek: zod_1.z.number().min(0).max(6).optional(),
    dayOfMonth: zod_1.z.number().min(1).max(31).optional(),
    hourUtc: zod_1.z.number().min(0).max(23),
    recipients: zod_1.z.array(exports.ReportScheduleRecipientSchema),
    format: exports.ReportScheduleFormatSchema,
    naturalLanguageQuery: zod_1.z.string().optional(),
    enabled: zod_1.z.boolean(),
    createdBy: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    lastRunAt: zod_1.z.string().optional(),
    nextRunAt: zod_1.z.string(),
});
exports.ReportScheduleCreateInputSchema = zod_1.z.object({
    reportType: zod_1.z.string(),
    reportParams: zod_1.z.record(zod_1.z.unknown()),
    frequency: exports.ReportScheduleFrequencySchema,
    dayOfWeek: zod_1.z.number().min(0).max(6).optional(),
    dayOfMonth: zod_1.z.number().min(1).max(31).optional(),
    hourUtc: zod_1.z.number().min(0).max(23),
    recipients: zod_1.z.array(exports.ReportScheduleRecipientSchema),
    format: exports.ReportScheduleFormatSchema,
    naturalLanguageQuery: zod_1.z.string().optional(),
    enabled: zod_1.z.boolean().optional().default(true),
});
//# sourceMappingURL=report-schedule.schema.js.map